export default __webpack_public_path__ + "static/media/ifet.74037b89.png";